module.exports = __webpack_public_path__ + "assets/img/Bedstitest_RMI632_logoSPLASH_RGB.278d3190.png";